import {
	AccountApiFactory,
	LogsApiFactory,
	MetricsApiFactory,
	StorageApiFactory,
	UsersApiFactory,
	MigrationsApiFactory,
	ContentApiFactory,
	NetworkStatusApiFactory,
	ContentTypesApiFactory,
	TaxonomiesApiFactory,
	CategoriesApiFactory,
	ContentTypeConfigsApiFactory,
	AdminApiFactory,
	DeploymentApiFactory,
	ConnectionsApiFactory,
	AIApiFactory
} from "./API";
import { createBackupClient, BackupClient } from "./Pages/Backup/backupClient";


class Client {

    get account() {
        return AccountApiFactory();
    }

    get metrics() {
        return MetricsApiFactory();
    }

    get logs() {
        return LogsApiFactory();
    }

	get users() {
		return UsersApiFactory();
	}

	get storage() {
		return StorageApiFactory();
	}

	get migrations() {
		return MigrationsApiFactory();
	}

	get content() {
		return ContentApiFactory();
	}

	get networkStatus() {
		return NetworkStatusApiFactory();
	}

	get contentTypes() {
		return ContentTypesApiFactory();
	}

	get backup(): BackupClient {
		return createBackupClient();
	}

	get taxonomies() {
		return TaxonomiesApiFactory();
	}

	get categories() {
		return CategoriesApiFactory();
	}

	get contentTypeConfigs() {
		return ContentTypeConfigsApiFactory();
	}

	get deployment() {
		return DeploymentApiFactory();
	}

	get connections() {
		return ConnectionsApiFactory();
	}

	get admin() {
		return AdminApiFactory();
	}

	get ai() {
		return AIApiFactory();
	}
}

export var client = new Client();
